module.exports = __webpack_public_path__ + "static/img/Patrick-Cripps.4c7ce59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick-Cripps.jpg
// module id = /8ql
// module chunks = 0